import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeworkLockedModal.css';

/**
 * Shown when a child taps a homework card their teacher has locked behind the
 * daily test.
 *
 * A modal rather than a full page on purpose: the thing we want them to do next
 * is the 🧠 card sitting a few centimetres above, so throwing the dashboard away
 * to say "go back and tap that" is the one layout that hides the answer. Closing
 * this returns them to it.
 *
 * @param {{ owed: number, studentId?: string, onClose: () => void }} props
 */
export function HomeworkLockedModal({ owed, studentId, onClose }) {
  const navigate = useNavigate();
  const target = studentId ? `/daily-test/${studentId}` : '/daily-test';

  return (
    <div
      className="hw-locked-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="hw-locked-title"
      data-testid="homework-locked-modal"
      onClick={onClose}
    >
      <div className="hw-locked-card" onClick={(e) => e.stopPropagation()}>
        <div className="hw-locked-icon" aria-hidden="true">🧠</div>
        <h2 className="hw-locked-title" id="hw-locked-title">先完成每日复习</h2>
        <p className="hw-locked-body">
          老师开启了「先复习，再做作业」。
          {owed > 1
            ? `把落下的 ${owed} 天复习补完，作业就会解锁。`
            : '把今天的每日复习做完，作业就会解锁。'}
        </p>
        <button
          type="button"
          className="hw-locked-btn hw-locked-btn--primary"
          onClick={() => navigate(target)}
        >
          去复习
        </button>
        <button type="button" className="hw-locked-btn hw-locked-btn--ghost" onClick={onClose}>
          知道了
        </button>
      </div>
    </div>
  );
}

export default HomeworkLockedModal;
